import BentoPieceRectangle from '@contentful-components/bento-box/pieces/bento-piece-rectangle'
import type { BentoOneFragment } from '@graphql/queries/GetBentoOne.graphql'
import { useEffect, useState } from 'react'
import type { ComponentType, FunctionComponent } from 'react'

import styles from './bento-one.module.scss'

type CarouselProps = Pick<BentoOneFragment, 'pieces'>

export const BentoOne: FunctionComponent<Props> = ({ pieces }) => {
    const [Carousel, setCarousel] =
        useState<ComponentType<CarouselProps> | null>(null)

    const isCarousel = pieces && pieces.items.length > 1

    useEffect(() => {
        if (!isCarousel) return
        import('./bento-one-carousel').then((mod) => {
            setCarousel(() => mod.BentoOneCarousel)
        })
    }, [isCarousel])

    return (
        <div className={styles.container}>
            <div className={styles.flexContainer}>
                {pieces?.items.length === 1 && (
                    <BentoPieceRectangle rectangle={pieces?.items[0]} />
                )}

                {/* SSR: render first slide; client: upgrade to carousel */}
                {isCarousel && !Carousel && (
                    <BentoPieceRectangle rectangle={pieces.items[0]} />
                )}

                {isCarousel && Carousel && <Carousel pieces={pieces} />}
            </div>
        </div>
    )
}

export default BentoOne

type Props = Omit<BentoOneFragment, 'sys' | 'type'> & {
    index?: number
}
